import { isProd } from '@/utils/helpers';
import { zo } from 'remote/global';

const loginSchema = zo.object({
  email: zo.string().min(1).email(),
  // TODO: Someday change our environment test accounts to accept only passwords longer than 8 chars
  password: isProd ? zo.string().min(1).min(8).max(128) : zo.string().min(1).max(128),
});

type LoginSchemaType = zo.infer<typeof loginSchema>;

export { loginSchema };
export type { LoginSchemaType };
